import { API_BASE, authHeaders } from './apiAuth'

/**
 * A person's own settings, kept with their account (workers/api/src/routes/
 * prefs.ts): the website's skin and a board's paper (2026-10-02). Callers keep
 * a copy in the browser as well and treat these as the word that wins once it
 * arrives; a failure here only means the browser's copy stands.
 */

/** 'workflows': the person's own workflows in the board's toolbar (workflowStore.ts, 2026-10-16). */
/** 'moodboard': the look the Miro mood board starts with (miro/lib/moodboardStyle.ts, 2026-10-27). */
export type PrefKey = 'theme' | 'board' | 'ui' | 'workflows' | 'moodboard'

export async function readPref(key: PrefKey): Promise<unknown> {
  const response = await fetch(`${API_BASE}/api/prefs?key=${key}`, {
    headers: { Accept: 'application/json', ...(await authHeaders()) },
  })
  if (!response.ok) throw new Error(`Could not read the setting (HTTP ${response.status})`)
  return ((await response.json()) as { value?: unknown }).value ?? null
}

const pending = new Map<PrefKey, number>()

/** Keep a setting; several in quick succession (a slider) send only the last. */
export function savePref(key: PrefKey, value: unknown, waitMs = 600): void {
  const was = pending.get(key)
  if (was !== undefined) window.clearTimeout(was)
  pending.set(
    key,
    window.setTimeout(() => {
      pending.delete(key)
      void (async () => {
        try {
          await fetch(`${API_BASE}/api/prefs`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...(await authHeaders()) },
            body: JSON.stringify({ key, value }),
          })
        } catch (error) {
          console.warn('could not keep the setting', error)
        }
      })()
    }, waitMs),
  )
}
